import { createIcon } from "@chakra-ui/react";

export const LinkedInCircle = createIcon({
  displayName: "LinkedIn",
  viewBox: "0 0 44 44",
  path: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x=".2" y="0" width="43" height="43" rx="21.5" fill="#fff" />
      <path
        d="M107.8 0H.2v107.7h107.6V0ZM10.1 11.6c0-.9.8-1.7 1.8-1.7h20c1 0 1.7.8 1.7 1.7v20.2c0 1-.7 1.7-1.7 1.7h-20c-1 0-1.8-.8-1.8-1.7V11.6Zm7.2 18V19h-3.6v10.6h3.6Zm-1.8-12c1.2 0 2-.8 2-1.8s-.8-1.9-2-1.9-2 .8-2 1.9c0 1 .8 1.8 2 1.8Zm3.7 12h3.5v-5.9c0-.3 0-.6.2-.8.2-.7.8-1.3 1.8-1.3 1.2 0 1.7 1 1.7 2.4v5.6H30v-6c0-3.3-1.8-4.8-4-4.8-2 0-2.8 1-3.3 1.7V19h-3.5v10.6Z"
        fill="#0052BA"
      />
      <rect x=".2" y="0" rx="21.5" fill="#fff" />
    </svg>
  ),
});
